// Adapter: convert a Zod ZodError into the AntD Form-friendly shape so
// schema-side errors land on the right fields with the same callsite as
// API-side `fields` errors.
//
// `aliases` ({ 'email': ['business_details', 'business_email'], … }) redirects
// errors for fields the form doesn't show to the field that supplied the value.
function resolvePath(path, aliases) {
  const key = path.join('.');
  return aliases?.[key] ?? aliases?.[path[0]] ?? path;
}

export function applyZodErrors(zodError, form, aliases) {
  const fields = zodError.issues.map((issue) => ({
    name: resolvePath(issue.path, aliases),
    errors: [issue.message],
  }));
  form.setFields(fields);
}

export function applyApiFieldErrors(apiError, form, aliases) {
  if (!apiError?.fields) return;
  const fields = Object.entries(apiError.fields).map(([name, message]) => ({
    name: resolvePath(name.split('.'), aliases),
    errors: [message],
  }));
  form.setFields(fields);
}
